import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './static-page-header.magic.css.js';
import script from './static-page-header.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.personalisedOffers.length>0 && _vm.showMobilePersonalisedOffers && _vm.isHomePage)?_c('magic-personalised-offers',{staticClass:"personalised-offers-container-mobile",attrs:{"part":"personalised-offers-container-mobile","show-mobile-personalised-offers":_vm.showMobilePersonalisedOffers},domProps:{"personalisedOffers":_vm.personalisedOffers}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header",class:[{
            'header--one-third': _vm.oneThird,
            'header--one-fourth': _vm.oneFourth,
            'header--show-content': _vm.showContent,
            'header--top-nav': _vm.topNav,
            'header--transparent': _vm.transparent,
            'header--narrow': _vm.narrow,
        }],attrs:{"data-v-test-id":"header","part":_vm.$p('header', [{
            'header--one-third': _vm.oneThird,
            'header--one-fourth': _vm.oneFourth,
            'header--show-content': _vm.showContent,
            'header--top-nav': _vm.topNav,
            'header--transparent': _vm.transparent,
            'header--narrow': _vm.narrow,
        }])}},[(_vm.page)?_c('div',{staticClass:"inner",class:{
                'inner--enhanced' : _vm.shouldApplyEnhancedSize,
                'inner--enhanced--faq': _vm.isFaqPage && _vm.shouldApplyEnhancedSize,
                'inner--enhanced--leaderboards': _vm.isLeaderboardsPage && _vm.shouldApplyEnhancedSize
            },attrs:{"part":"inner"}},[(_vm.personalisedOffers.length>0 && !_vm.showMobilePersonalisedOffers && _vm.isHomePage)?_c('magic-personalised-offers',{staticClass:"personalised-offers-container",attrs:{"part":"personalised-offers-container","show-mobile-personalised-offers":_vm.showMobilePersonalisedOffers},domProps:{"personalisedOffers":_vm.personalisedOffers}}):_vm._e(),_vm._v(" "),(_vm.page.background)?_c('magic-ui-background',{staticClass:"background",attrs:{"part":"background","path":_vm.shouldReplaceBgWithImage ? _vm.page.image : _vm.page.background,"image-type":_vm.shouldReplaceBgWithImage ? 'page-images': null,"alt":_vm.page.title}}):_vm._e(),_vm._v(" "),(_vm.image || _vm.page.title || _vm.page.description || _vm.content)?_c('div',{staticClass:"wrapper",class:{ 'wrapper--top-nav': _vm.topNav, 'wrapper-narrow': _vm.narrow },attrs:{"part":_vm.$p('wrapper', { 'wrapper--top-nav': _vm.topNav })}},[(!_vm.hideImage && _vm.image)?_c('img',{staticClass:"image",attrs:{"part":"image","alt":"Image","src":_vm.image}}):_vm._e(),_vm._v(" "),(!_vm.hideTitle && _vm.page.title)?_c('magic-ui-text',{staticClass:"title",class:_vm.enhancedCoversEnabled && 'title--enhanced',attrs:{"tag":"h3","part":"title","content":_vm.page.title}}):_vm._e(),_vm._v(" "),(!_vm.hideDescription && _vm.page.description)?_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.page.description}}):_vm._e(),_vm._v(" "),(_vm.showContent && _vm.content)?_c('magic-ui-text',{staticClass:"content",attrs:{"is-markdown":"","part":"content","marketing-banner-text":_vm.marketingBanner,"content":_vm.content}}):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._e()],1):_vm._e()])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0ca16815_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-0ca16815";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
